import { Redirect } from '@reach/router';
import React, { Suspense } from 'react';
import { isLoggedIn } from '../../utils/auth';
import { Layout } from '../layout';

const PrivateRoute = (props) => {
  // const { isOpen, onClose, onOpen } = useDisclosure();
  // const [initialStep, setInitialStep] = useState(0);
  if (!isLoggedIn()) {
    return <Redirect to="/login" noThrow />;
  }
  const { children, component: Component, location, ...rest } = props;
  return (
    <Layout isUserNav>
      {/* <MerchantOnboardingHandler /> */}
      <Suspense fallback={<div>Loading...</div>}>
        <Component {...rest} />
      </Suspense>
      {/* <WelcomeStepsModal
        initialStep={initialStep}
        isOpen={isOpen}
        onClose={onClose}
      /> */}
      {/* {children} */}
    </Layout>
  );
};

export default PrivateRoute;
